import PageStyle from "@/styles/components/progressline/_index.module.scss";
import Button  from "@/components/button";
import { REDIRECT } from "@/constants/common/urls";



export function NextSteps({pending_steps, router}) 
{
  function redirectStep(router, step){
    let url = `${REDIRECT.client.quick_setup}${step}`;
    router.push(url)
  }
   
  return(
    <>
    {pending_steps?.length > 0 && <div className={PageStyle.ProgressLineSection__AcionSection}>
      <h4>Actions to be taken</h4>
      <ul className={PageStyle.ProgressLineSection__ActionButtons}>
        {
          pending_steps.map((step, index) => {
           switch(step){
            case 'add_teams':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>Add Teams</Button></li>)
              break;
            case 'company_integrations':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>Company Integrations</Button></li>)
              break;
            case 'careers_page':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>Careers Page</Button></li>)
              break;
            case 'privacy_policy':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>Privacy Policy</Button></li>)
              break;
            case 'my_account':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>My Account</Button></li>)
              break;
            case 'my_integrations':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>My Integrations</Button></li>)
              break;
            case 'my_preferences':
              return (<li key={`onboarding-step-${index}`}><Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> redirectStep(router, step)}>My Preferences</Button></li>)
              break;
            }
          })
        }
      </ul>
    </div>
    }
    </>
    )
  
}
